<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :termination-reason="terminationReason"
            :can-edit-short-name="canEditShortName"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/LovTerminationReasons/Form.vue'
import { route } from '~@/Composables/route'

defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    terminationReason: {
        type: Object,
        default: () => { return {} }
    },
    canEditShortName: {
        type: Boolean,
        default: () => { return false }
    }
})

function submitForm (form) {
    form.put(
        route('settings.termination-reasons.update', form.id)
    )
}
</script>

<style scoped>

</style>
